import React, { useState } from 'react';
import { Badge, Box } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { SocialProviderUnitDto } from '../../../../api-service/clients';
import { FavoriteDropdownWithStorage } from '../../../../components/favorite-dropdown';
import { ColorPalette } from '../../../../components/config/color-palette';
import { formatSocialProviderUnitByName } from '../../../offer-and-activity/utilities';
import { serviceProviderUnitStorage } from '../services/service-provider-unit-storage';

const EXPANDED_WIDTH = 280;
const ICON_SIZE = 24;

export interface IServiceProviderOpticDropdown {
  units: SocialProviderUnitDto[];
  selectedUnitId: string | undefined;
  onSelectUnit: (unitId: string) => void;
  selectedUnitAbbreviation?: string | undefined;
  label?: string;
  getUnitLabel?: (unit: SocialProviderUnitDto) => string;
  sortUnits?: (a: SocialProviderUnitDto, b: SocialProviderUnitDto) => number;
}

export function ServiceProviderOpticDropdown(
  props: IServiceProviderOpticDropdown
) {
  const {
    units,
    selectedUnitId,
    onSelectUnit,
    selectedUnitAbbreviation,
    label = 'Udførerenhed',
    getUnitLabel = formatSocialProviderUnitByName,
    sortUnits,
  } = props;
  const [hover, setHover] = useState(false);

  function handleSelectUnit(unit: SocialProviderUnitDto) {
    if (unit.id) {
      onSelectUnit(unit.id);
    }
    setHover(false);
  }

  const dropdown = (
    <FavoriteDropdownWithStorage
      items={units}
      selectedItemId={selectedUnitId}
      onSelectItem={handleSelectUnit}
      storage={{
        getFavoriteId: serviceProviderUnitStorage.getFavoriteUnitId,
        setFavoriteId: serviceProviderUnitStorage.setFavoriteUnitId,
        clearFavoriteId: serviceProviderUnitStorage.clearFavoriteUnitId,
      }}
      getItemId={unit => unit.id}
      getItemLabel={getUnitLabel}
      sortItems={sortUnits}
      label={label}
      minWidth={EXPANDED_WIDTH}
    />
  );

  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        minWidth: ICON_SIZE,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: ColorPalette.WHITE,
          flexShrink: 0,
        }}
        aria-hidden
      >
        <Badge
          badgeContent={selectedUnitAbbreviation}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
        >
          <Visibility sx={{ fontSize: ICON_SIZE }} />
        </Badge>
      </Box>
      <Box
        sx={{
          maxWidth: hover ? EXPANDED_WIDTH : 0,
          overflow: 'hidden',
          opacity: hover ? 1 : 0,
          transition: 'max-width 0.2s ease-out, opacity 0.15s ease-out',
        }}
      >
        {dropdown}
      </Box>
    </Box>
  );
}
